// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withHandlers } from '../../../../../../../node_module_clones/recompose';

// Utils
import { getElementId } from '../../../../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { findIcons, setIconPopupMode } from './iconsPopupActions';

// Components
import IconList from './tabContent/iconList/IconList';
import IconTabContentImagePicker from './tabContent/imagePicker/IconTabContentImagePicker';

import PopupModeMenu from '../../../../../../components/popupPanel/types/modeMenu/PopupModeMenu';
import PopupModeContent from '../../../../../../components/popupPanel/types/modeContent/PopupModeContent';
import { GroupTranslatorProvider, useGroupTranslator } from '../../../../../../components/i18n/GroupTranslationContext';

// Constants
import { IconUiCategory } from '../iconToolTypes';

import iconPopupSelector from './iconPopupSelector';

import './IconPopup.scss';

const popupModeHasChanged = (props, nextProps) => nextProps.popupMode !== props.popupMode;
const popupModeIsImages = (props) => props.popupMode === IconUiCategory.IMAGES;
const popupBecameActive = (props, nextProps) => nextProps.isActive && !props.isActive;

const shouldSearchForIcons = (props, nextProps) =>
    (popupModeHasChanged(props, nextProps) || popupBecameActive(props, nextProps)) &&
    !popupModeIsImages(nextProps) &&
    !nextProps.iconList;

const mapDispatchToProps = (dispatch) => ({
    searchForIcons: ({ query, id }) => dispatch(findIcons({ query, id })),
    setMode: ({ mode, id }) => {
        if (!mode) return;
        dispatch(setIconPopupMode({ mode, id }));
    },
});

@connect(iconPopupSelector, mapDispatchToProps)
@withHandlers({
    submitSearch:
        ({ setMode, selectedElements }) =>
        (query) => {
            setMode({ mode: query, id: selectedElements && getElementId(selectedElements.first()) });
        },
    setModeDefault:
        ({ setMode, selectedElements }) =>
        (event) => {
            event && event.preventDefault();
            setMode({ mode: IconUiCategory.DEFAULT });
        },
})
class IconPopup extends React.Component {
    componentDidMount() {
        const { searchForIcons, popupQuery, selectedElements, iconList } = this.props;

        if (!iconList?.length) {
            searchForIcons({
                query: popupQuery,
                id: getElementId(selectedElements.first()),
            });
        }
    }

    componentDidUpdate(prevProps) {
        const { searchForIcons } = this.props;

        if (!this.props.isActive) return;

        if (shouldSearchForIcons(prevProps, this.props)) {
            searchForIcons({
                query: this.props.popupQuery,
                id: getElementId(this.props.selectedElements.first()),
            });
        }
    }

    render() {
        return (
            <GroupTranslatorProvider group="popup" keyPrefix="icon">
                <IconPopupContent {...this.props} />
            </GroupTranslatorProvider>
        );
    }
}

const IconPopupContent = (props) => {
    const groupTranslate = useGroupTranslator();

    return (
        <div className="icon-popup-content">
            <PopupModeMenu
                {...props}
                showSearch
                searchPlaceholder={groupTranslate('searchPlaceholder') + '...'}
            />
            <PopupModeContent>
                {popupModeIsImages(props) ? <IconTabContentImagePicker {...props} /> : <IconList {...props} />}
            </PopupModeContent>
        </div>
    );
};

IconPopup.propTypes = {
    gridSize: PropTypes.number.isRequired,
    isActive: PropTypes.bool,
    selectedElements: PropTypes.object,
    iconList: PropTypes.object,
    popupMode: PropTypes.string,
    modeList: PropTypes.array,
    popupQuery: PropTypes.string,
    setMode: PropTypes.func,
    setModeDefault: PropTypes.func,
    submitQuery: PropTypes.func,
    searchForIcons: PropTypes.func,
};

export default IconPopup;
